export const Mohadi = {
  lat: 20.1453,
  lng: 73.8934,
}
